import { UserState } from "../../../contexts/userContext";

import { VoteSpace } from "../../../services/hotColdVoteServices";

import CommonButton from "../../Button";
import CommonPopup from "..";

type Props = {
  popup: string;
  onClose?: () => void;
  onMove?: () => void;
  user: UserState;
  voteSpace?: VoteSpace;
};

export default function HotColdVoteOnGoingPopup({
  popup,
  onClose,
  onMove,
  user,
}: Props) {
  return (
    <CommonPopup isOpen={popup === "onGoing"} onClose={onClose} padding={0}>
      <div className="whitespace-pre-line text-xl font-medium p-7 leading-[30px] break-keep">
        {`${user.nickname} 님!`}
        {`\n현재 ${user.buildingName ?? ""}`}
        <span className="text-brand-primary-magenta font-semibold">
          {` ${user.buildingFloorName ?? ""} ${user.buildingSpaceName ?? ""}`}
        </span>
        {"에서 투표가 진행중입니다. 투표로 이동하시겠습니까?"}
      </div>
      <div className="flex">
        <CommonButton
          variant="secondary"
          className="rounded-none flex-1 h-bottom-button"
          onClick={onClose}
        >
          취소
        </CommonButton>
        <CommonButton
          className="rounded-none flex-1 h-bottom-button w-full"
          onClick={onMove}
        >
          이동
        </CommonButton>
      </div>
    </CommonPopup>
  );
}
